<template>
  <th :class="headerClass" :aria-sort="ariaSort">
    <button type="button" class="sortable-table-header" :aria-label="ariaLabel" @click="$emit('sort', field)">
      <span>{{ $t(label) }}</span>
      <AppIcon :name="iconClass" class="bi ms-1" :class="iconClass" aria-hidden="true" />
    </button>
  </th>
</template>

<script>
export default {
  name: 'SortableTableHeader',
  props: {
    field: { type: String, required: true },
    label: { type: String, required: true },
    sortField: { type: String, required: true },
    sortDirection: { type: String, required: true },
    headerClass: { type: String, default: 'pt-4 pb-3 px-6' }
  },
  computed: {
    isActive() {
      return this.sortField === this.field;
    },
    nextDirection() {
      return this.isActive && this.sortDirection === 'asc' ? 'descending' : 'ascending';
    },
    ariaSort() {
      if (!this.isActive) return 'none';
      return this.sortDirection === 'asc' ? 'ascending' : 'descending';
    },
    ariaLabel() {
      return `${this.$t('sort_by')} ${this.$t(this.label)} (${this.$t(this.nextDirection)})`;
    },
    iconClass() {
      if (!this.isActive) return 'bi-arrow-down-up';
      return this.sortDirection === 'asc' ? 'bi-chevron-up' : 'bi-chevron-down';
    }
  }
}
</script>

<style scoped>
.sortable-table-header {
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  font-weight: inherit;
  white-space: nowrap;
}

.sortable-table-header:hover,
.sortable-table-header:focus-visible {
  color: var(--bs-primary);
}
</style>
